"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRebuildValue = useRebuildValue;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

/**
 * easy hook can rebuild state when prop value change
 * */
function useRebuildValue(value) {
  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      mergeValue = _useState2[0],
      setMergValue = _useState2[1];

  (0, _react.useEffect)(function () {
    setMergValue(value);
  }, [JSON.stringify({
    serialization: value
  })]);
  return [mergeValue, setMergValue];
}
//# sourceMappingURL=hook.js.map